import { getDecorationTonalStyle } from '#pplx/frontend/aether/components/Decoration/colors.js';
import { swatches } from '#pplx_generated/pplx/frontend/design-tokens/tokens/swatches.js';
export const ICON_PICKER_COLOR_NAMES = [
    'gray',
    'red',
    'orange',
    'amber',
    'lime',
    'green',
    'teal',
    'blue',
    'indigo',
    'purple',
    'pink',
];
// Persisted names predate Aether's Decoration names, so preserve their
// established palette mapping in dark mode.
const COLOR_DEFINITIONS = {
    red: ['ifrit', 'pink'],
    orange: ['phoenix', 'orange'],
    amber: ['titan', 'gold'],
    lime: ['sylph', 'lime'],
    green: ['garuda', 'green'],
    teal: ['shiva', 'teal'],
    blue: ['leviathan', 'blue'],
    indigo: ['fenrir', 'indigo'],
    purple: ['ramuh', 'purple'],
    pink: ['jenova', 'magenta'],
};
const GRAY_COLOR_STYLE = {
    background: 'var(--bg-subtle)',
    icon: 'var(--fg-secondary)',
};
export function isIconPickerColorName(value) {
    return value != null && ICON_PICKER_COLOR_NAMES.includes(value);
}
function lightSwatchHex(base, step) {
    const swatchKey = `${base}Light${step}`;
    return swatches[swatchKey].hex(false);
}
/**
 * Resolves a persisted icon-picker color to its theme-aware presentation.
 * Unknown values fall back to gray so consumers can safely render older data.
 */
export function getIconPickerColorStyle(colorName, colorScheme = 'light') {
    if (!isIconPickerColorName(colorName) || colorName === 'gray') {
        return GRAY_COLOR_STYLE;
    }
    const [lightSwatchBase, decorationColor] = COLOR_DEFINITIONS[colorName];
    if (colorScheme === 'dark') {
        const tonalStyle = getDecorationTonalStyle(decorationColor);
        return {
            background: tonalStyle.backgroundColor,
            icon: tonalStyle.foregroundColor,
        };
    }
    return {
        background: lightSwatchHex(lightSwatchBase, '50'),
        icon: lightSwatchHex(lightSwatchBase, '500'),
    };
}
//# sourceMappingURL=index.js.map